import { Col, Row } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';
import './components/articles/assets/css/article.css';

import user from './components/articles/assets/images/user.svg';

import calendar from './components/articles/assets/images/calendar-article.svg';
import checklist from './components/articles/assets/images/checklist.svg';
import magnifier from './components/articles/assets/images/magnifier.svg';

export const imagePaths = {
  appLake: require('./components/home/assets/images/app-lake-placeholder.webp'),

  checked: require('./components/home/assets/images/checked-bullet.svg')
    .default,
  appQR: require('./components/home/assets/images/AppDownload.svg').default,
  appStoreIcon:
    require('./components/common/assets/images/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg')
      .default,
  googlePlayIcon: require('./components/common/assets/images/google-play-badge.png'),
};
function ErrorPage() {
  return (
    <div>
      <div
        className='main_container_padding__content w-full'
        style={{ maxWidth: '1200px !important' }}
      >
        <Row>
          <Col className='gutter-row' span={24}>
            <div className='error-page-masthead'>
              <div className='articles-page-masthead__content'>
                <h1 className='articles-page-masthead__title white gSemiBold mg-bottom-0'>
                  swimbooker
                </h1>
                <div className='articles-page-masthead__paragraph txt-center gMedium'>
                  Less Hassle. More Fishing
                </div>
              </div>
            </div>
            <div className='error-page-text grey-900 gBold fs-20 mg-auto'>
              <span className='gMedium'>This fishery or page</span> could not be
              found! Use the buttons below to take your next step...
            </div>
          </Col>
        </Row>

        <Col span={24} className='mg-bottom-100 other-pages-wrapper'>
          <div>
            <div
              className='gBold fs-40 mg-bottom-50 txt-center'
              style={{ color: 'rgba(31, 35, 38, 0.96)' }}
            >
              Where to next?...
            </div>
            <Row gutter={[0, 20]} className='justify-center mg-bottom-50'>
              <Link to='/join' className='other-page-buttons '>
                <img src={user} alt='user' className='mg-right-10' />
                Create your account
              </Link>

              <Link to='/search' className='other-page-buttons '>
                <img src={calendar} alt='calendar' className='mg-right-10' />
                Find your next venue
              </Link>

              <a
                href={`${process.env.REACT_APP_SBPLUS_URL}/sign-up`}
                className='other-page-buttons '
              >
                <img src={magnifier} alt='magnifier' className='mg-right-10' />
                Explore swimbooker+
              </a>

              <Link
                to='/swimbooker-fishery-manager'
                className='other-page-buttons '
              >
                <img src={checklist} alt='checklist' className='mg-right-10' />
                List your lakes with us
              </Link>
            </Row>
          </div>
          <Row className='mobile-app-container'>
            <div className='img-container'>
              <img src={imagePaths.appLake} alt='lake-image' />
            </div>
            <div
              className='  justify-between'
              style={{
                flex: 1,
                flexDirection: 'column',
                padding: '20px 20px 15px ',
              }}
            >
              <div className='row-center flex-wrap'>
                <div className='benefits'>
                  <div className='fs-32 grey-900 gBold mg-bottom-20 text-center'>
                    Go further with the swimbooker app
                  </div>
                  <div>
                    <div className='fs-18 gSemiBold grey-800 mg-bottom-15'>
                      <img
                        src={imagePaths.checked}
                        alt='checked'
                        className='mg-right-15'
                      />
                      Direct Notification Updates
                    </div>
                    <div className='fs-18 gSemiBold grey-800 mg-bottom-15'>
                      <img
                        src={imagePaths.checked}
                        alt='checked'
                        className='mg-right-15'
                      />
                      MySB - Your Angler Hub
                    </div>
                    <div className='fs-18 gSemiBold grey-800 mg-bottom-15'>
                      <img
                        src={imagePaths.checked}
                        alt='checked'
                        className='mg-right-15'
                      />
                      Advanced Catch Reports
                    </div>
                    <div className='fs-18 gSemiBold grey-800 mg-bottom-15'>
                      <img
                        src={imagePaths.checked}
                        alt='checked'
                        className='mg-right-15'
                      />
                      Live Availability
                    </div>
                  </div>
                </div>
                <div className='QR'>
                  <img src={imagePaths.appQR} alt='app-qr' />
                </div>
                <div className='app-mobile-icons'>
                  <a
                    href={
                      'https://apps.apple.com/gb/app/swimbooker/id1586855906'
                    }
                    className={'sb-footer__app_link'}
                  >
                    <img
                      src={imagePaths.appStoreIcon}
                      alt={'Download on the App Store'}
                    />
                  </a>
                  <a
                    className={'sb-footer__app_link'}
                    href='https://play.google.com/store/apps/details?id=com.app.swimbookerapp&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'
                  >
                    <img
                      src={imagePaths.googlePlayIcon}
                      alt='Get it on Google Play'
                    />
                  </a>
                </div>
              </div>
              <div className='gSemiBold fs-20 grey-900 text'>
                Scan the QR code with your device camera and download our app
              </div>
            </div>
          </Row>
        </Col>
      </div>
    </div>
  );
}

export default ErrorPage;
